module.exports = __webpack_public_path__ + "static/media/sz.f358077f.svg";